import * as React from 'react';
import styles from './index.less';
import LocalUpload from '@/pages/resource/creator/Step2/LocalUpload';
import StorageSpace from '@/pages/resource/creator/Step2/StorageSpace';
import MarkdownEditor from '@/pages/resource/creator/Step2/MarkdownEditor';
import CartoonEditor from '@/pages/resource/creator/Step2/CartoonEditor';
import FComponentsLib from '@freelog/components-lib';
import { FI18n, FUtil } from '@freelog/tools-lib';
import img from '@/assets/file-object.svg';
import FTooltip from '@/components/FTooltip';
import { Progress, Space } from 'antd';
import fResourceOptionEditor from '@/components/fResourceOptionEditor';
import FResourceOptions from '@/components/FResourceOptions';
import { connect } from 'dva';
import { ConnectState, ResourceVersionCreatorPageModelState } from '@/models/connect';
import { Dispatch } from 'redux';
import { RouteComponentProps } from 'react-router/index';
import * as AHooks from 'ahooks';
import FCoverImage from '@/components/FCoverImage';
import {
  ChangeAction,
  OnChange_CustomConfigurations_Action,
  OnChange_CustomProperties_Action,
  OnChange_DescriptionText_Action,
  OnChange_IsOpenCartoon_Action,
  OnChange_VersionInput_Action,
  OnClick_CreateVersionBtn_Action,
  OnClick_OpenCartoonBtn_Action,
  OnClose_CartoonEditor_Action,
  OnClose_MarkdownEditor_Action,
  OnDelete_ObjectFile_Action,
  OnMountPageAction,
  OnSucceed_ImportObject_Action,
  OnSucceed_UploadFile_Action,
  OnTrigger_SaveDraft_Action,
  OnUnmountPageAction,
} from '@/models/resourceVersionCreatorPage';
import FReleaseTip from '@/components/FReleaseTip';
import FVersionInput from '@/components/FVersionInput';
import FPrompt from '@/components/FPrompt';
import FSkeletonNode from '@/components/FSkeletonNode';
import { withRouter, history } from 'umi';
import FMicroApp_MarkdownEditorDrawer from '@/components/FMicroApp_MarkdownEditorDrawer';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import FMicroApp_CartoonEditorDrawer from '@/components/FMicroApp_CartoonEditorDrawer';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import { VersionDescriptionEditor } from '@/pages/resource/collectionSidebar/versionInfo/$id';
import FIcons from '@/components/FIcons';
import FAttrsAndConfigs, { IAttrsAndConfigsItem } from '@/components/FAttrsAndConfigs';
import fResourcePropertyEditor3 from '@/components/fResourcePropertyEditor3';

interface VersionCreatorProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
  resourceVersionCreatorPage: ResourceVersionCreatorPageModelState;
}

function VersionCreator({ match, dispatch, resourceVersionCreatorPage }: VersionCreatorProps) {
  const [$showMore, set$ShowMore, get$ShowMore] = FUtil.Hook.useGetState<boolean>(false);
  const [$versionInputHasError, set$versionInputHasError] = FUtil.Hook.useGetState<boolean>(false);
  const [isMarkdownEditorDirty, set_isMarkdownEditorDirty] = FUtil.Hook.useGetState<boolean>(false);

  const [$uploadingInfo, set$uploadingInfo, get$uploadingInfo] = FUtil.Hook.useGetState<null | {
    name: string;
    percent: number;
    cancelHandler: any;
  }>(null);

  AHooks.useMount(() => {
    dispatch<OnMountPageAction>({
      type: 'resourceVersionCreatorPage/onMountPage',
      payload: {
        resourceID: match.params.id,
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmountPageAction>({
      type: 'resourceVersionCreatorPage/onUnmountPage',
    });
  });

  AHooks.useDebounceEffect(
    () => {
      if (resourceVersionCreatorPage.dataIsDirty) {
        dispatch<OnTrigger_SaveDraft_Action>({
          type: 'resourceVersionCreatorPage/onTrigger_SaveDraft',
          payload: {
            showSuccessTip: false,
          },
        });
      }
    },
    [resourceVersionCreatorPage.dataIsDirty, resourceVersionCreatorPage.descriptionText],
    {
      wait: 300,
    },
  );

  async function onClick_EditMarkdownBtn() {
    await dispatch<OnTrigger_SaveDraft_Action>({
      type: 'resourceVersionCreatorPage/onTrigger_SaveDraft',
      payload: {
        showSuccessTip: false,
      },
    });
    dispatch<ChangeAction>({
      type: 'resourceVersionCreatorPage/change',
      payload: {
        isOpenMarkdown: true,
      },
    });
  }

  async function onClose_EditMarkdown() {
    dispatch<ChangeAction>({
      type: 'resourceVersionCreatorPage/change',
      payload: {
        isOpenMarkdown: false,
      },
    });
    await set_isMarkdownEditorDirty(false);
    await dispatch<OnClose_MarkdownEditor_Action>({
      type: 'resourceVersionCreatorPage/onClose_MarkdownEditor',
    });
  }

  const hasError: boolean =
    resourceVersionCreatorPage.versionInput === '' ||
    $versionInputHasError ||
    !resourceVersionCreatorPage.selectedFileInfo ||
    resourceVersionCreatorPage.systemPropertiesState !== 'success' ||
    !resourceVersionCreatorPage.isCompleteAuthorization;

  return (
    <>
      <div
        className={styles.noSelectedFileInfo}
        style={{
          display: !resourceVersionCreatorPage.selectedFileInfo ? 'flex' : 'none',
        }}
      >
        <div style={{ height: 40 }} />
        <div style={{ display: 'flex', alignItems: 'center', width: 920 }}>
          <a
            href={FUtil.LinkTo.resourceVersionInfo({
              resourceID: resourceVersionCreatorPage.resourceInfo?.resourceID || '',
              version: resourceVersionCreatorPage.resourceInfo?.latestVersion || undefined,
            })}
            target={'_blank'}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <div style={{ width: 36, height: 27, position: 'relative' }}>
              <FCoverImage
                src={resourceVersionCreatorPage.resourceInfo?.cover || ''}
                width={36}
                style={{ borderRadius: 4 }}
              />
              <img
                src={img_choiceLabel}
                alt={''}
                style={{
                  width: 12,
                  height: 12,
                  position: 'absolute',
                  top: 2,
                  left: 2,
                }}
              />
            </div>
            <div style={{ width: 10 }} />
            <FComponentsLib.FContentText
              text={
                resourceVersionCreatorPage.resourceInfo?.resourceTitle ||
                resourceVersionCreatorPage.resourceInfo?.resourceName ||
                ''
              }
              type={'highlight'}
              style={{
                maxWidth: 490,
              }}
              singleRow
            />
            <div style={{ width: 5 }} />
            <label
              style={{
                backgroundColor: '#E4E7EB',
                borderRadius: 4,
                fontSize: 12,
                color: '#666',
                padding: '0 5px',
                lineHeight: '18px',
                display: 'inline-block',
                maxWidth: 240,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {resourceVersionCreatorPage.resourceInfo?.resourceType.join('/')}
            </label>
            <div style={{ width: 10 }} />
            <FComponentsLib.FTitleText text={'/'} type={'h1'} />
          </a>

          <div style={{ width: 10 }} />
          <FComponentsLib.FTitleText
            // text={'新建版本'}
            text={FI18n.i18nNext.t('create_new_version_newversion')}
            type={'h1'}
          />
        </div>
        <div style={{ height: 100 }} />
        {!!$uploadingInfo && (
          <div style={{ width: 920 }}>
            <div className={styles.fileInfo}>
              <div className={styles.card}>
                <img src={img} className={styles.img} alt='' />
                <div style={{ width: 20 }} />
                <div>
                  <FComponentsLib.FContentText
                    type='highlight'
                    text={$uploadingInfo?.name || ''}
                    style={{ maxWidth: 600 }}
                    singleRow
                  />
                  <div style={{ height: 18 }} />
                  <div className={styles.info}>
                    <FComponentsLib.FContentText
                      className={styles.infoSize}
                      type='additional1'
                      text={'本地上传'}
                    />
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', width: 270 }}>
                <FComponentsLib.FContentText
                  text={`${$uploadingInfo?.percent || 0}%`}
                  type={'additional1'}
                  style={{ color: '#222' }}
                />
                <div style={{ width: 10 }} />
                <Progress
                  percent={$uploadingInfo?.percent || 0}
                  showInfo={false}
                  style={{ width: 140 }}
                />
                <div style={{ width: 20 }} />
                {$uploadingInfo?.percent === 100 ? (
                  <FComponentsLib.FTextBtn style={{ fontSize: 12 }} type={'primary'}>
                    正在解析
                  </FComponentsLib.FTextBtn>
                ) : (
                  <FComponentsLib.FTextBtn
                    style={{ fontSize: 12 }}
                    type={'danger'}
                    onClick={() => {
                      const uploadingInfo = get$uploadingInfo();
                      uploadingInfo && uploadingInfo.cancelHandler();
                      set$uploadingInfo(null);
                    }}
                  >
                    取消上传
                  </FComponentsLib.FTextBtn>
                )}
              </div>
            </div>
          </div>
        )}

        {!$uploadingInfo && (
          <div className={styles.styles}>
            {resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes('localUpload') && (
              <LocalUpload
                limitFileSize={resourceVersionCreatorPage.resourceTypeConfig.limitFileSize}
                style={{ width: '100%', flexGrow: 1 }}
                resourceTypeCode={resourceVersionCreatorPage.resourceInfo?.resourceTypeCode || ''}
                onSucceed={(value) => {
                  dispatch<OnSucceed_UploadFile_Action>({
                    type: 'resourceVersionCreatorPage/onSucceed_UploadFile',
                    payload: {
                      name: value.fileName,
                      sha1: value.sha1,
                    },
                  });
                }}
                onChange_uploadingInfo={(value) => {
                  set$uploadingInfo(value);
                }}
              />
            )}

            {resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes('storageSpace') && (
              <StorageSpace
                style={{ width: '100%', flexGrow: 1 }}
                resourceTypeCode={resourceVersionCreatorPage.resourceInfo?.resourceTypeCode || ''}
                onSucceed={(value) => {
                  dispatch<OnSucceed_ImportObject_Action>({
                    type: 'resourceVersionCreatorPage/onSucceed_ImportObject',
                    payload: {
                      name: value.objectName,
                      sha1: value.sha1,
                      objID: value.objectID,
                    },
                  });
                }}
              />
            )}

            {resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes(
              'markdownEditor',
            ) && (
              <MarkdownEditor
                style={{ width: '100%', flexGrow: 1 }}
                onClickBtn={() => {
                  onClick_EditMarkdownBtn();
                }}
              />
            )}

            {resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes(
              'cartoonEditor',
            ) && (
              <CartoonEditor
                style={{ width: '100%', flexGrow: 1 }}
                onClickBtn={() => {
                  dispatch<OnClick_OpenCartoonBtn_Action>({
                    type: 'resourceVersionCreatorPage/onClick_OpenCartoonBtn',
                  });
                }}
              />
            )}
          </div>
        )}

        <div style={{ height: 100 }} />

        <FReleaseTip visible={resourceVersionCreatorPage.releaseTipVisible} />
      </div>
      <FPrompt
        watch={
          resourceVersionCreatorPage.dataIsDirty ||
          isMarkdownEditorDirty ||
          resourceVersionCreatorPage.isDirtyMarkdownEditor ||
          resourceVersionCreatorPage.isDirtyCartoonEditor
        }
        onOk={(locationHref) => {
          history.push(locationHref);
          dispatch<OnChange_IsOpenCartoon_Action>({
            type: 'resourceVersionCreatorPage/onChange_IsOpenCartoon',
            payload: {
              value: false,
            },
          });
        }}
      />

      <div
        className={styles.selectedFileInfo}
        style={{
          display: resourceVersionCreatorPage.selectedFileInfo ? 'flex' : 'none',
        }}
      >
        <div style={{ width: 920 }}>
          <div style={{ height: 40 }} />
          <div style={{ display: 'flex', alignItems: 'center', width: 920 }}>
            <a
              style={{ display: 'flex', alignItems: 'center' }}
              href={FUtil.LinkTo.resourceVersionInfo({
                resourceID: resourceVersionCreatorPage.resourceInfo?.resourceID || '',
                version: resourceVersionCreatorPage.resourceInfo?.latestVersion || undefined,
              })}
              target={'_blank'}
            >
              <div style={{ width: 36, height: 27, position: 'relative' }}>
                <FCoverImage
                  src={resourceVersionCreatorPage.resourceInfo?.cover || ''}
                  width={36}
                  style={{ borderRadius: 4 }}
                />
                <img
                  src={img_choiceLabel}
                  alt={''}
                  style={{
                    width: 12,
                    height: 12,
                    position: 'absolute',
                    top: 2,
                    left: 2,
                  }}
                />
              </div>
              <div style={{ width: 10 }} />
              <FComponentsLib.FContentText
                text={
                  resourceVersionCreatorPage.resourceInfo?.resourceTitle ||
                  resourceVersionCreatorPage.resourceInfo?.resourceName ||
                  ''
                }
                type={'highlight'}
              />
              <div style={{ width: 5 }} />
              <label
                style={{
                  backgroundColor: '#E4E7EB',
                  borderRadius: 4,
                  fontSize: 12,
                  color: '#666',
                  padding: '0 5px',
                  lineHeight: '18px',
                  display: 'inline-block',
                }}
              >
                {resourceVersionCreatorPage.resourceInfo?.resourceType.join('/')}
              </label>
              <div style={{ width: 10 }} />
              <FComponentsLib.FTitleText text={'/'} type={'h1'} />
            </a>

            <div style={{ width: 10 }} />
            <FComponentsLib.FTitleText
              // text={'新建版本'}
              text={FI18n.i18nNext.t('create_new_version_newversion')}
              type={'h1'}
            />
          </div>
          <div style={{ height: 30 }} />
          <FVersionInput
            value={resourceVersionCreatorPage.versionInput}
            resourceLatestVersion={
              resourceVersionCreatorPage.resourceInfo?.latestVersion || '1.0.0'
            }
            onChange={(value) => {
              dispatch<OnChange_VersionInput_Action>({
                type: 'resourceVersionCreatorPage/onChange_VersionInput',
                payload: {
                  value: value,
                },
              });
            }}
            onChangeError={(hasError) => {
              console.log(hasError, 'hasErroriosdjflkjsdlkfjlk sdlkfjlkj');
              set$versionInputHasError(hasError);
            }}
          />

          <div style={{ height: 30 }} />

          <div className={styles.fileInfo}>
            <div className={styles.card}>
              <img src={img} className={styles.img} alt='' />
              <div style={{ width: 20 }} />
              <div>
                <FComponentsLib.FContentText
                  type='highlight'
                  text={resourceVersionCreatorPage.selectedFileInfo?.name || ''}
                  style={{ maxWidth: 600 }}
                  singleRow
                />
                <div style={{ height: 18 }} />
                <div className={styles.info}>
                  <FComponentsLib.FContentText
                    className={styles.infoSize}
                    type='additional1'
                    text={resourceVersionCreatorPage.selectedFileInfo?.from || ''}
                  />
                </div>
              </div>
            </div>
            <Space size={10}>
              {resourceVersionCreatorPage.resourceTypeConfig.isSupportEdit && (
                <>
                  <FComponentsLib.FTextBtn
                    disabled={resourceVersionCreatorPage.systemPropertiesState === 'parsing'}
                    type='primary'
                    style={{
                      fontSize: 12,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 5,
                    }}
                    onClick={async () => {
                      if (
                        resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes(
                          'markdownEditor',
                        )
                      ) {
                        onClick_EditMarkdownBtn();
                      } else if (
                        resourceVersionCreatorPage.resourceTypeConfig.uploadEntry.includes(
                          'cartoonEditor',
                        )
                      ) {
                        dispatch<OnClick_OpenCartoonBtn_Action>({
                          type: 'resourceVersionCreatorPage/onClick_OpenCartoonBtn',
                        });
                      }
                    }}
                  >
                    <FIcons.FEdit style={{ fontSize: 12 }} />
                    {/* <span>编辑</span> */}
                    {FI18n.i18nNext.t('create_new_version_edit')}
                  </FComponentsLib.FTextBtn>
                </>
              )}

              {resourceVersionCreatorPage.resourceTypeConfig.isSupportDownload && (
                <FComponentsLib.FTextBtn
                  type='primary'
                  disabled={resourceVersionCreatorPage.systemPropertiesState === 'parsing'}
                  style={{
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5,
                  }}
                  onClick={() => {
                    if (!resourceVersionCreatorPage.selectedFileInfo) {
                      return;
                    }
                    self.location.href =
                      FUtil.Format.completeUrlByDomain('api') +
                      `/v2/storages/files/${
                        resourceVersionCreatorPage.selectedFileInfo?.sha1 || ''
                      }/download?attachmentName=${
                        resourceVersionCreatorPage.selectedFileInfo?.name || 'download'
                      }`;
                  }}
                >
                  <FIcons.FDownload style={{ fontSize: 12 }} />
                  {/* <span>下载</span> */}
                  <span>{FI18n.i18nNext.t('edit_resource_vmgnt_btn_download')}</span>
                </FComponentsLib.FTextBtn>
              )}

              <FComponentsLib.FTextBtn
                type='danger'
                style={{
                  fontSize: 12,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
                // disabled={$prop.disabledOperations?.includes('remove')}
                onClick={async () => {
                  dispatch<OnDelete_ObjectFile_Action>({
                    type: 'resourceVersionCreatorPage/onDelete_ObjectFile',
                  });
                }}
              >
                <FIcons.FDelete style={{ fontSize: 12 }} />
                <span>{FI18n.i18nNext.t('remove')}</span>
              </FComponentsLib.FTextBtn>
            </Space>
          </div>

          <div style={{ height: 5 }} />

          {resourceVersionCreatorPage.systemPropertiesState === 'parsing' && (
            <>
              <div style={{ height: 20 }} />
              <FSkeletonNode width={920} height={38} />
              <div style={{ height: 20 }} />
              <FSkeletonNode width={340} height={38} />
            </>
          )}

          {resourceVersionCreatorPage.systemPropertiesState === 'success' && (
            <>
              <div className={styles.block}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <FComponentsLib.FContentText
                    // text={'基础属性'}
                    text={FI18n.i18nNext.t('resourceinfo_title')}
                    type={'highlight'}
                  />
                  {resourceVersionCreatorPage.customProperties.length < 30 && (
                    <Space size={10}>
                      <FTooltip title={FI18n.i18nNext.t('resourceinfo_add_btn_info')}>
                        <div>
                          <FComponentsLib.FTextBtn
                            style={{
                              fontSize: 12,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 5,
                            }}
                            type='primary'
                            onClick={async () => {
                              const dataSource: {
                                key: string;
                                name: string;
                                description: string;
                              } | null = await fResourcePropertyEditor3({
                                disabledKeys: [
                                  ...resourceVersionCreatorPage.systemProperties.map<string>(
                                    (rp) => rp.key,
                                  ),
                                  ...resourceVersionCreatorPage.customProperties.map<string>(
                                    (bp) => bp.key,
                                  ),
                                  ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                    (pp) => pp.key,
                                  ),
                                ],
                                disabledNames: [
                                  ...resourceVersionCreatorPage.systemProperties.map<string>(
                                    (rp) => rp.name,
                                  ),
                                  ...resourceVersionCreatorPage.customProperties.map<string>(
                                    (bp) => bp.name,
                                  ),
                                  ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                    (pp) => pp.name,
                                  ),
                                ],
                              });
                              if (!dataSource) {
                                return;
                              }

                              await dispatch<OnChange_CustomProperties_Action>({
                                type: 'resourceVersionCreatorPage/onChange_CustomProperties',
                                payload: {
                                  value: [
                                    ...resourceVersionCreatorPage.customProperties,
                                    { ...dataSource, value: '' },
                                  ],
                                },
                              });
                            }}
                          >
                            <FIcons.FProperty style={{ fontSize: 14 }} />
                            {/* <span>补充属性</span> */}
                            <span>{FI18n.i18nNext.t('resourceinfo_add_title')}</span>
                          </FComponentsLib.FTextBtn>
                        </div>
                      </FTooltip>
                    </Space>
                  )}
                </div>

                {[
                  ...resourceVersionCreatorPage.systemProperties.filter((rp) => {
                    return !(rp.type === 'raw' && rp.value === '');
                  }),
                  // ...resourceVersionCreatorPage.additionalProperties,
                  ...resourceVersionCreatorPage.customProperties,
                ].length === 0 && (
                  <>
                    <div style={{ height: 10 }} />
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {/*<span>{FI18n.i18nNext.t('resourceoptions_list_empty')}</span>*/}
                      <FComponentsLib.FContentText
                        text={FI18n.i18nNext.t('resourceinfo_empty_msg')}
                        type={'additional2'}
                        style={{ maxWidth: 600, textAlign: 'center' }}
                      />
                    </div>
                    {/*<div style={{ height: 20 }} />*/}
                  </>
                )}

                {[
                  ...resourceVersionCreatorPage.systemProperties.filter((rp) => {
                    return !(rp.type === 'raw' && rp.value === '');
                  }),
                  ...resourceVersionCreatorPage.customProperties,
                ].length > 0 && (
                  <>
                    <div style={{ height: 20 }} />
                    <FAttrsAndConfigs
                      dateSource={[
                        ...resourceVersionCreatorPage.systemProperties.map<IAttrsAndConfigsItem>(
                          (sp) => {
                            return {
                              key: sp.key,
                              value: sp.value,
                              name: sp.name,
                              description: sp.description,
                              configs: {
                                item_Deletable: false,
                                key_Editable: false,
                                name_Editable: false,
                                description_Editable: false,
                                value_Editable:
                                  (sp.type === 'additional' && sp.valueConfig) || false,
                              },
                            };
                          },
                        ),
                        ...resourceVersionCreatorPage.customProperties.map<IAttrsAndConfigsItem>(
                          (cp) => {
                            return {
                              key: cp.key,
                              value: cp.value,
                              name: cp.name,
                              description: cp.description,
                              configs: {
                                item_Deletable: true,
                                key_Editable: true,
                                name_Editable: true,
                                description_Editable: true,
                                value_Editable: {
                                  text: {
                                    nullable: true,
                                    minLength: 0,
                                    maxLength: 140,
                                  },
                                },
                              },
                            };
                          },
                        ),
                      ]}
                      onChangeItem={(oldData, newData, index) => {
                        if (index < resourceVersionCreatorPage.systemProperties.length) {
                          const newDateSource = [...resourceVersionCreatorPage.systemProperties];
                          newDateSource[index] = {
                            key: newData.key,
                            name: newData.name,
                            value: newData.value,
                            description: newData.description,
                            type: resourceVersionCreatorPage.systemProperties[index].type,
                            valueConfig:
                              resourceVersionCreatorPage.systemProperties[index].valueConfig,
                          };

                          dispatch<ChangeAction>({
                            type: 'resourceVersionCreatorPage/change',
                            payload: {
                              systemProperties: newDateSource,
                              dataIsDirty: true,
                            },
                          });
                        } else {
                          const newDateSource = [...resourceVersionCreatorPage.customProperties];
                          newDateSource[
                            index - resourceVersionCreatorPage.systemProperties.length
                          ] = {
                            key: newData.key,
                            name: newData.name,
                            value: newData.value,
                            description: newData.description,
                          };
                          dispatch<OnChange_CustomProperties_Action>({
                            type: 'resourceVersionCreatorPage/onChange_CustomProperties',
                            payload: {
                              value: newDateSource,
                            },
                          });
                        }
                      }}
                      onDeleteItem={(value) => {
                        dispatch<OnChange_CustomProperties_Action>({
                          type: 'resourceVersionCreatorPage/onChange_CustomProperties',
                          payload: {
                            value: resourceVersionCreatorPage.customProperties.filter((cp) => {
                              return cp.key !== value.key && cp.name !== value.name;
                            }),
                          },
                        });
                      }}
                      disabledKeys={[
                        ...resourceVersionCreatorPage.systemProperties.map<string>((rp) => rp.key),
                        ...resourceVersionCreatorPage.customProperties.map<string>((cp) => cp.key),
                        ...resourceVersionCreatorPage.customConfigurations.map<string>(
                          (cp) => cp.key,
                        ),
                      ]}
                      disabledNames={[
                        ...resourceVersionCreatorPage.systemProperties.map<string>((rp) => rp.name),
                        ...resourceVersionCreatorPage.customProperties.map<string>((cp) => cp.name),
                        ...resourceVersionCreatorPage.customConfigurations.map<string>(
                          (cp) => cp.name,
                        ),
                      ]}
                    />
                  </>
                )}
              </div>

              <div style={{ height: 15 }} />

              {$showMore ? (
                <FComponentsLib.FTextBtn
                  style={{ fontSize: 12 }}
                  type={'primary'}
                  onClick={() => {
                    set$ShowMore(false);
                  }}
                >
                  {FI18n.i18nNext.t('create_new_version_btn_showless')}
                </FComponentsLib.FTextBtn>
              ) : (
                <Space size={10}>
                  <FComponentsLib.FTextBtn
                    style={{ fontSize: 12 }}
                    type={'primary'}
                    onClick={() => {
                      set$ShowMore(true);
                    }}
                  >
                    {/* 更多设置 */}
                    {FI18n.i18nNext.t('create_new_version_btn_moresetting')}
                  </FComponentsLib.FTextBtn>
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('create_new_version_btn_moresetting_help')}
                    type={'additional2'}
                  />
                </Space>
              )}
            </>
          )}

          <div style={{ display: $showMore ? 'block' : 'none' }}>
            <div style={{ height: 10 }} />
            {resourceVersionCreatorPage.resourceTypeConfig.isSupportOptionalConfig && (
              <>
                <div className={styles.block}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <FComponentsLib.FContentText
                      text={FI18n.i18nNext.t('resourceoptions_title')}
                      type={'highlight'}
                    />

                    {resourceVersionCreatorPage.customConfigurations.length < 30 && (
                      <Space size={10}>
                        <FTooltip title={FI18n.i18nNext.t('info_versionoptions')}>
                          <div>
                            <FComponentsLib.FTextBtn
                              style={{
                                fontSize: 12,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5,
                              }}
                              type='primary'
                              onClick={async () => {
                                const dataSource: {
                                  key: string;
                                  name: string;
                                  type: 'input' | 'select';
                                  input: string;
                                  select: string[];
                                  description: string;
                                } | null = await fResourceOptionEditor({
                                  disabledKeys: [
                                    ...resourceVersionCreatorPage.systemProperties.map<string>(
                                      (rp) => rp.key,
                                    ),
                                    ...resourceVersionCreatorPage.customProperties.map<string>(
                                      (bp) => bp.key,
                                    ),
                                    ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                      (pp) => pp.key,
                                    ),
                                  ],
                                  disabledNames: [
                                    ...resourceVersionCreatorPage.systemProperties.map<string>(
                                      (rp) => rp.name,
                                    ),
                                    ...resourceVersionCreatorPage.customProperties.map<string>(
                                      (bp) => bp.name,
                                    ),
                                    ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                      (pp) => pp.name,
                                    ),
                                  ],
                                });

                                if (!dataSource) {
                                  return;
                                }

                                await dispatch<OnChange_CustomConfigurations_Action>({
                                  type: 'resourceVersionCreatorPage/onChange_CustomConfigurations',
                                  payload: {
                                    value: [
                                      ...resourceVersionCreatorPage.customConfigurations,
                                      dataSource,
                                    ],
                                  },
                                });
                              }}
                            >
                              <FIcons.FConfiguration style={{ fontSize: 14 }} />
                              <span>{FI18n.i18nNext.t('resourceoptions_add_btn')}</span>
                            </FComponentsLib.FTextBtn>
                          </div>
                        </FTooltip>
                      </Space>
                    )}
                  </div>

                  {resourceVersionCreatorPage.customConfigurations.length === 0 && (
                    <>
                      <div style={{ height: 10 }} />
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <FComponentsLib.FContentText
                          text={FI18n.i18nNext.t('resourceoptions_list_empty')}
                          type={'additional2'}
                        />
                      </div>
                      <div style={{ height: 20 }} />
                    </>
                  )}

                  {resourceVersionCreatorPage.customConfigurations.length > 0 && (
                    <>
                      <div style={{ height: 20 }} />
                      <FResourceOptions
                        theme={'dark'}
                        // dataSource={resourceVersionCreatorPage.customOptionsData}
                        dataSource={resourceVersionCreatorPage.customConfigurations}
                        onEdit={async (value) => {
                          const index: number =
                            resourceVersionCreatorPage.customConfigurations.findIndex((p) => {
                              return p === value;
                            });

                          const dataSource: {
                            key: string;
                            name: string;
                            type: 'input' | 'select';
                            input: string;
                            select: string[];
                            description: string;
                          } | null = await fResourceOptionEditor({
                            disabledKeys: [
                              ...resourceVersionCreatorPage.systemProperties.map<string>(
                                (rp) => rp.key,
                              ),
                              ...resourceVersionCreatorPage.customProperties.map<string>(
                                (bp) => bp.key,
                              ),
                              ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                (pp) => pp.key,
                              ),
                            ],
                            disabledNames: [
                              ...resourceVersionCreatorPage.systemProperties.map<string>(
                                (rp) => rp.name,
                                ``,
                              ),
                              ...resourceVersionCreatorPage.customProperties.map<string>(
                                (bp) => bp.name,
                              ),
                              ...resourceVersionCreatorPage.customConfigurations.map<string>(
                                (pp) => pp.name,
                              ),
                            ],
                            defaultData: value,
                          });

                          if (!dataSource) {
                            return;
                          }

                          await dispatch<OnChange_CustomConfigurations_Action>({
                            type: 'resourceVersionCreatorPage/onChange_CustomConfigurations',
                            payload: {
                              value: resourceVersionCreatorPage.customConfigurations.map((a, b) => {
                                if (b !== index) {
                                  return a;
                                }
                                return dataSource;
                              }),
                            },
                          });
                        }}
                        onDelete={async (value) => {
                          await dispatch<OnChange_CustomConfigurations_Action>({
                            type: 'resourceVersionCreatorPage/onChange_CustomConfigurations',
                            payload: {
                              value: resourceVersionCreatorPage.customConfigurations.filter((a) => {
                                return a.key !== value.key && a.name !== value.name;
                              }),
                            },
                          });
                        }}
                      />
                    </>
                  )}
                </div>

                <div style={{ height: 5 }} />
              </>
            )}

            <div className={styles.block}>
              {resourceVersionCreatorPage.resourceInfo &&
                resourceVersionCreatorPage.authReload > 0 && (
                  <FMicroAPP_Authorization
                    // reload={resourceVersionCreatorPage.authReload}
                    licenseeId={resourceVersionCreatorPage.resourceInfo.resourceID}
                    licenseeVersion={resourceVersionCreatorPage.versionInput}
                    mainAppType={'resourceInVersionUpdate'}
                    depList={resourceVersionCreatorPage.directDependencies}
                    upcastList={resourceVersionCreatorPage.baseUpcastResources}
                    mount={(data) => {
                      set$ShowMore(get$ShowMore() || (data.directDependencies || []).length > 0);
                      dispatch<ChangeAction>({
                        type: 'resourceVersionCreatorPage/change',
                        payload: {
                          directDependencies: data.directDependencies || [],
                          // resolveResources: data.resolveResources,
                          baseUpcastResources: data.baseUpcastResources || [],
                          isCompleteAuthorization: data.isAllAuthComplete || false,
                          // dataIsDirty: true,
                          authExcludedItems: data.authExcludedItems || [],
                        },
                      });
                    }}
                    update={(data) => {
                      // console.log(
                      //   data,
                      //   'DDDDDDDFFSDFSD AF89weurfoiewuiofjlsjdakkf',
                      // );
                      set$ShowMore(get$ShowMore() || (data.directDependencies || []).length > 0);
                      dispatch<ChangeAction>({
                        type: 'resourceVersionCreatorPage/change',
                        payload: {
                          directDependencies: data.directDependencies || [],
                          // resolveResources: data.resolveResources,
                          baseUpcastResources: data.baseUpcastResources || [],
                          isCompleteAuthorization: data.isAllAuthComplete || false,
                          dataIsDirty: true,
                          authExcludedItems: data.authExcludedItems || [],
                        },
                      });
                    }}
                  />
                )}
            </div>
          </div>

          <div style={{ height: 10 }} />

          <VersionDescriptionEditor
            value={resourceVersionCreatorPage.descriptionText}
            onChange={(value) => {
              dispatch<OnChange_DescriptionText_Action>({
                type: 'resourceVersionCreatorPage/onChange_DescriptionText',
                payload: {
                  value: value,
                },
              });
            }}
          />
          <div style={{ height: 30 }} />

          <div className={styles.btn}>
            {resourceVersionCreatorPage.draftSaveTime && (
              <FComponentsLib.FContentText
                text={`已保存 ${resourceVersionCreatorPage.draftSaveTime}`}
                type={'additional2'}
              />
            )}

            {/*{FI18n.i18nNext.t('rqr_step3_btn_later')}*/}
            <FComponentsLib.FTextBtn
              type={'default'}
              onClick={() => {
                dispatch<OnTrigger_SaveDraft_Action>({
                  type: 'resourceVersionCreatorPage/onTrigger_SaveDraft',
                  payload: {
                    showSuccessTip: true,
                  },
                });
              }}
            >
              {FI18n.i18nNext.t('save_as_draft')}
            </FComponentsLib.FTextBtn>
            {/*{FI18n.i18nNext.t('rqr_step3_btn_next')}*/}
            <FComponentsLib.FRectBtn
              disabled={hasError}
              type={'primary'}
              onClick={() => {
                dispatch<OnClick_CreateVersionBtn_Action>({
                  type: 'resourceVersionCreatorPage/onClick_CreateVersionBtn',
                });
              }}
            >
              {FI18n.i18nNext.t('release_to_market')}
            </FComponentsLib.FRectBtn>
          </div>

          <div style={{ height: 100 }} />
        </div>
      </div>

      <FMicroApp_MarkdownEditorDrawer
        open={resourceVersionCreatorPage.isOpenMarkdown}
        resourceID={resourceVersionCreatorPage.resourceInfo?.resourceID || ''}
        onChange_Saved={(saved) => {
          dispatch<ChangeAction>({
            type: 'resourceVersionCreatorPage/change',
            payload: {
              isDirtyMarkdownEditor: !saved,
            },
          });
        }}
        onClose={() => {
          console.log('FMicroApp_MarkdownEditorDrawer Colse');
          onClose_EditMarkdown();
        }}
      />
      <FMicroApp_CartoonEditorDrawer
        open={resourceVersionCreatorPage.isOpenCartoon}
        resourceID={resourceVersionCreatorPage.resourceInfo?.resourceID || ''}
        onChange_Saved={(saved) => {
          // console.log(saved, 'saved sdifj;sldkjflkj');
          dispatch<ChangeAction>({
            type: 'resourceVersionCreatorPage/change',
            payload: {
              isDirtyCartoonEditor: !saved,
            },
          });
        }}
        onClose={() => {
          dispatch<OnClose_CartoonEditor_Action>({
            type: 'resourceVersionCreatorPage/onClose_CartoonEditor',
          });
        }}
      />
    </>
  );
}

export default withRouter(
  connect(({ resourceVersionCreatorPage }: ConnectState) => ({
    resourceVersionCreatorPage: resourceVersionCreatorPage,
  }))(VersionCreator),
);
